(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[90],{

/***/ 73090:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ PageWrapper_HomePageWrapper; }
});

// EXTERNAL MODULE: ./node_modules/.pnpm/react@17.0.2/node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(4637);
// EXTERNAL MODULE: ./node_modules/.pnpm/react-bootstrap@2.2.1_sfoxds7t5ydpegc3knd667wn6m/node_modules/react-bootstrap/esm/Container.js
var Container = __webpack_require__(28440);
// EXTERNAL MODULE: ./node_modules/.pnpm/react-bootstrap@2.2.1_sfoxds7t5ydpegc3knd667wn6m/node_modules/react-bootstrap/esm/Row.js
var Row = __webpack_require__(44858);
// EXTERNAL MODULE: ./node_modules/.pnpm/react-bootstrap@2.2.1_sfoxds7t5ydpegc3knd667wn6m/node_modules/react-bootstrap/esm/Col.js
var Col = __webpack_require__(42359);
// EXTERNAL MODULE: ./node_modules/.pnpm/react-bootstrap@2.2.1_sfoxds7t5ydpegc3knd667wn6m/node_modules/react-bootstrap/esm/Button.js
var Button = __webpack_require__(46863);
// EXTERNAL MODULE: ./src/hooks/useModal.ts
var useModal = __webpack_require__(5330);
// EXTERNAL MODULE: ./src/components/_modal/MessageBox/index.tsx
var MessageBox = __webpack_require__(29089);
// EXTERNAL MODULE: ./node_modules/.pnpm/react@17.0.2/node_modules/react/index.js
var react = __webpack_require__(59496);
// EXTERNAL MODULE: ./node_modules/.pnpm/next@12.1.0_n6febsnk4nq7zxsovmf65ymnxm/node_modules/next/dist/compiled/regenerator-runtime/runtime.js
var runtime = __webpack_require__(95601);
var runtime_default = /*#__PURE__*/__webpack_require__.n(runtime);
// EXTERNAL MODULE: ./src/components/_form/Field/index.tsx
var Field = __webpack_require__(50509);
// EXTERNAL MODULE: ./node_modules/.pnpm/react-bootstrap@2.2.1_sfoxds7t5ydpegc3knd667wn6m/node_modules/react-bootstrap/esm/Form.js + 15 modules
var Form = __webpack_require__(28268);
// EXTERNAL MODULE: ./src/components/_modal/FormModal/index.tsx
var FormModal = __webpack_require__(72552);
;// CONCATENATED MODULE: ./src/consts/recaptchaKey.ts
var recaptchaKey = "6LfxMhwTAAAAAHyibsWatF9-4RMpNBrZsBba5892" || 0;
/* harmony default export */ var consts_recaptchaKey = (recaptchaKey);

// EXTERNAL MODULE: ./node_modules/.pnpm/prop-types@15.8.1/node_modules/prop-types/index.js
var prop_types = __webpack_require__(40507);
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);
;// CONCATENATED MODULE: ./node_modules/.pnpm/react-google-recaptcha@2.1.0_react@17.0.2/node_modules/react-google-recaptcha/lib/esm/recaptcha.js
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }




var ReCAPTCHA =
/*#__PURE__*/
function (_React$Component) {
  _inheritsLoose(ReCAPTCHA, _React$Component);

  function ReCAPTCHA() {
    var _this;

    _this = _React$Component.call(this) || this;
    _this.handleExpired = _this.handleExpired.bind(_assertThisInitialized(_this));
    _this.handleErrored = _this.handleErrored.bind(_assertThisInitialized(_this));
    _this.handleChange = _this.handleChange.bind(_assertThisInitialized(_this));
    _this.handleRecaptchaRef = _this.handleRecaptchaRef.bind(_assertThisInitialized(_this));
    return _this;
  }

  var _proto = ReCAPTCHA.prototype;

  _proto.getValue = function getValue() {
    if (this.props.grecaptcha && this._widgetId !== undefined) {
      return this.props.grecaptcha.getResponse(this._widgetId);
    }

    return null;
  };

  _proto.getWidgetId = function getWidgetId() {
    if (this.props.grecaptcha && this._widgetId !== undefined) {
      return this._widgetId;
    }

    return null;
  };

  _proto.execute = function execute() {
    var grecaptcha = this.props.grecaptcha;

    if (grecaptcha && this._widgetId !== undefined) {
      return grecaptcha.execute(this._widgetId);
    } else {
      this._executeRequested = true;
    }
  };

  _proto.executeAsync = function executeAsync() {
    var _this2 = this;

    return new Promise(function (resolve, reject) {
      _this2.executionResolve = resolve;
      _this2.executionReject = reject;

      _this2.execute();
    });
  };

  _proto.reset = function reset() {
    if (this.props.grecaptcha && this._widgetId !== undefined) {
      this.props.grecaptcha.reset(this._widgetId);
    }
  };

  _proto.handleExpired = function handleExpired() {
    if (this.props.onExpired) {
      this.props.onExpired();
    } else {
      this.handleChange(null);
    }
  };

  _proto.handleErrored = function handleErrored() {
    if (this.props.onErrored) {
      this.props.onErrored();
    }

    if (this.executionReject) {
      this.executionReject();
      delete this.executionResolve;
      delete this.executionReject;
    }
  };

  _proto.handleChange = function handleChange(token) {
    if (this.props.onChange) {
      this.props.onChange(token);
    }

    if (this.executionResolve) {
      this.executionResolve(token);
      delete this.executionReject;
      delete this.executionResolve;
    }
  };

  _proto.explicitRender = function explicitRender() {
    if (this.props.grecaptcha && this.props.grecaptcha.render && this._widgetId === undefined) {
      var wrapper = document.createElement("div");
      this._widgetId = this.props.grecaptcha.render(wrapper, {
        sitekey: this.props.sitekey,
        callback: this.handleChange,
        theme: this.props.theme,
        type: this.props.type,
        tabindex: this.props.tabindex,
        "expired-callback": this.handleExpired,
        "error-callback": this.handleErrored,
        size: this.props.size,
        stoken: this.props.stoken,
        hl: this.props.hl,
        badge: this.props.badge
      });
      this.captcha.appendChild(wrapper);
    }

    if (this._executeRequested && this.props.grecaptcha && this._widgetId !== undefined) {
      this._executeRequested = false;
      this.execute();
    }
  };

  _proto.componentDidMount = function componentDidMount() {
    this.explicitRender();
  };

  _proto.componentDidUpdate = function componentDidUpdate() {
    this.explicitRender();
  };

  _proto.componentWillUnmount = function componentWillUnmount() {
    if (this._widgetId !== undefined) {
      this.delayOfCaptchaIframeRemoving();
      this.reset();
    }
  };

  _proto.delayOfCaptchaIframeRemoving = function delayOfCaptchaIframeRemoving() {
    var temporaryNode = document.createElement("div");
    document.body.appendChild(temporaryNode);
    temporaryNode.style.display = "none"; // move of the recaptcha to a temporary node

    while (this.captcha.firstChild) {
      temporaryNode.appendChild(this.captcha.firstChild);
    } // delete the temporary node after reset will be done


    setTimeout(function () {
      document.body.removeChild(temporaryNode);
    }, 5000);
  };

  _proto.handleRecaptchaRef = function handleRecaptchaRef(elem) {
    this.captcha = elem;
  };

  _proto.render = function render() {
    // consume properties owned by the reCATPCHA, pass the rest to the div so the user can style it.

    /* eslint-disable no-unused-vars */
    var _this$props = this.props,
        sitekey = _this$props.sitekey,
        onChange = _this$props.onChange,
        theme = _this$props.theme,
        type = _this$props.type,
        tabindex = _this$props.tabindex,
        onExpired = _this$props.onExpired,
        onErrored = _this$props.onErrored,
        size = _this$props.size,
        stoken = _this$props.stoken,
        grecaptcha = _this$props.grecaptcha,
        badge = _this$props.badge,
        hl = _this$props.hl,
        childProps = _objectWithoutPropertiesLoose(_this$props, ["sitekey", "onChange", "theme", "type", "tabindex", "onExpired", "onErrored", "size", "stoken", "grecaptcha", "badge", "hl"]);
    /* eslint-enable no-unused-vars */


    return react.createElement("div", _extends({}, childProps, {
      ref: this.handleRecaptchaRef
    }));
  };

  return ReCAPTCHA;
}(react.Component);


ReCAPTCHA.displayName = "ReCAPTCHA";
ReCAPTCHA.propTypes = {
  sitekey: (prop_types_default()).string.isRequired,
  onChange: (prop_types_default()).func,
  grecaptcha: (prop_types_default()).object,
  theme: prop_types_default().oneOf(["dark", "light"]),
  type: prop_types_default().oneOf(["image", "audio"]),
  tabindex: (prop_types_default()).number,
  onExpired: (prop_types_default()).func,
  onErrored: (prop_types_default()).func,
  size: prop_types_default().oneOf(["compact", "normal", "invisible"]),
  stoken: (prop_types_default()).string,
  hl: (prop_types_default()).string,
  badge: prop_types_default().oneOf(["bottomright", "bottomleft", "inline"])
};
ReCAPTCHA.defaultProps = {
  onChange: function onChange() {},
  theme: "light",
  type: "image",
  tabindex: 0,
  size: "normal",
  badge: "bottomright"
};
// EXTERNAL MODULE: ./node_modules/.pnpm/hoist-non-react-statics@3.3.2/node_modules/hoist-non-react-statics/dist/hoist-non-react-statics.cjs.js
var hoist_non_react_statics_cjs = __webpack_require__(72535);
var hoist_non_react_statics_cjs_default = /*#__PURE__*/__webpack_require__.n(hoist_non_react_statics_cjs);
;// CONCATENATED MODULE: ./node_modules/.pnpm/react-async-script@1.2.0_react@17.0.2/node_modules/react-async-script/lib/esm/async-script-loader.js
function async_script_loader_extends() { async_script_loader_extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return async_script_loader_extends.apply(this, arguments); }

function async_script_loader_objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function async_script_loader_inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }




var SCRIPT_MAP = {}; // A counter used to generate a unique id for each component that uses the function

var idCount = 0;
function makeAsyncScript(getScriptURL, options) {
  options = options || {};
  return function wrapWithAsyncScript(WrappedComponent) {
    var wrappedComponentName = WrappedComponent.displayName || WrappedComponent.name || "Component";

    var AsyncScriptLoader =
    /*#__PURE__*/
    function (_Component) {
      async_script_loader_inheritsLoose(AsyncScriptLoader, _Component);

      function AsyncScriptLoader(props, context) {
        var _this;

        _this = _Component.call(this, props, context) || this;
        _this.state = {};
        _this.__scriptURL = "";
        return _this;
      }

      var _proto = AsyncScriptLoader.prototype;

      _proto.asyncScriptLoaderGetScriptLoaderID = function asyncScriptLoaderGetScriptLoaderID() {
        if (!this.__scriptLoaderID) {
          this.__scriptLoaderID = "async-script-loader-" + idCount++;
        }

        return this.__scriptLoaderID;
      };

      _proto.setupScriptURL = function setupScriptURL() {
        this.__scriptURL = typeof getScriptURL === "function" ? getScriptURL() : getScriptURL;
        return this.__scriptURL;
      };

      _proto.asyncScriptLoaderHandleLoad = function asyncScriptLoaderHandleLoad(state) {
        var _this2 = this;

        // use reacts setState callback to fire props.asyncScriptOnLoad with new state/entry
        this.setState(state, function () {
          return _this2.props.asyncScriptOnLoad && _this2.props.asyncScriptOnLoad(_this2.state);
        });
      };

      _proto.asyncScriptLoaderTriggerOnScriptLoaded = function asyncScriptLoaderTriggerOnScriptLoaded() {
        var mapEntry = SCRIPT_MAP[this.__scriptURL];

        if (!mapEntry || !mapEntry.loaded) {
          throw new Error("Script is not loaded.");
        }

        for (var obsKey in mapEntry.observers) {
          mapEntry.observers[obsKey](mapEntry);
        }

        delete window[options.callbackName];
      };

      _proto.componentDidMount = function componentDidMount() {
        var _this3 = this;

        var scriptURL = this.setupScriptURL();
        var key = this.asyncScriptLoaderGetScriptLoaderID();
        var _options = options,
            globalName = _options.globalName,
            callbackName = _options.callbackName,
            scriptId = _options.scriptId; // check if global object already attached to window

        if (globalName && typeof window[globalName] !== "undefined") {
          SCRIPT_MAP[scriptURL] = {
            loaded: true,
            observers: {}
          };
        } // check if script loading already


        if (SCRIPT_MAP[scriptURL]) {
          var entry = SCRIPT_MAP[scriptURL]; // if loaded or errored then "finish"

          if (entry && (entry.loaded || entry.errored)) {
            this.asyncScriptLoaderHandleLoad(entry);
            return;
          } // if still loading then callback to observer queue


          entry.observers[key] = function (entry) {
            return _this3.asyncScriptLoaderHandleLoad(entry);
          };

          return;
        }
        /*
         * hasn't started loading
         * start the "magic"
         * setup script to load and observers
         */


        var observers = {};

        observers[key] = function (entry) {
          return _this3.asyncScriptLoaderHandleLoad(entry);
        };

        SCRIPT_MAP[scriptURL] = {
          loaded: false,
          observers: observers
        };
        var script = document.createElement("script");
        script.src = scriptURL;
        script.async = true;

        for (var attribute in options.attributes) {
          script.setAttribute(attribute, options.attributes[attribute]);
        }

        if (scriptId) {
          script.id = scriptId;
        }

        var callObserverFuncAndRemoveObserver = function callObserverFuncAndRemoveObserver(func) {
          if (SCRIPT_MAP[scriptURL]) {
            var mapEntry = SCRIPT_MAP[scriptURL];
            var observersMap = mapEntry.observers;

            for (var obsKey in observersMap) {
              if (func(observersMap[obsKey])) {
                delete observersMap[obsKey];
              }
            }
          }
        };

        if (callbackName && typeof window !== "undefined") {
          window[callbackName] = function () {
            return _this3.asyncScriptLoaderTriggerOnScriptLoaded();
          };
        }

        script.onload = function () {
          var mapEntry = SCRIPT_MAP[scriptURL];

          if (mapEntry) {
            mapEntry.loaded = true;
            callObserverFuncAndRemoveObserver(function (observer) {
              if (callbackName) {
                return false;
              }

              observer(mapEntry);
              return true;
            });
          }
        };

        script.onerror = function () {
          var mapEntry = SCRIPT_MAP[scriptURL];

          if (mapEntry) {
            mapEntry.errored = true;
            callObserverFuncAndRemoveObserver(function (observer) {
              observer(mapEntry);
              return true;
            });
          }
        };

        document.body.appendChild(script);
      };

      _proto.componentWillUnmount = function componentWillUnmount() {
        // Remove tag script
        var scriptURL = this.__scriptURL;

        if (options.removeOnUnmount === true) {
          var allScripts = document.getElementsByTagName("script");

          for (var i = 0; i < allScripts.length; i += 1) {
            if (allScripts[i].src.indexOf(scriptURL) > -1) {
              if (allScripts[i].parentNode) {
                allScripts[i].parentNode.removeChild(allScripts[i]);
              }
            }
          }
        } // Clean the observer entry


        var mapEntry = SCRIPT_MAP[scriptURL];

        if (mapEntry) {
          delete mapEntry.observers[this.asyncScriptLoaderGetScriptLoaderID()];

          if (options.removeOnUnmount === true) {
            delete SCRIPT_MAP[scriptURL];
          }
        }
      };

      _proto.render = function render() {
        var globalName = options.globalName; // remove asyncScriptOnLoad from childProps

        var _this$props = this.props,
            asyncScriptOnLoad = _this$props.asyncScriptOnLoad,
            forwardedRef = _this$props.forwardedRef,
            childProps = async_script_loader_objectWithoutPropertiesLoose(_this$props, ["asyncScriptOnLoad", "forwardedRef"]); // eslint-disable-line no-unused-vars


        if (globalName && typeof window !== "undefined") {
          childProps[globalName] = typeof window[globalName] !== "undefined" ? window[globalName] : undefined;
        }

        childProps.ref = forwardedRef;
        return (0,react.createElement)(WrappedComponent, childProps);
      };

      return AsyncScriptLoader;
    }(react.Component); // Note the second param "ref" provided by React.forwardRef.
    // We can pass it along to AsyncScriptLoader as a regular prop, e.g. "forwardedRef"
    // And it can then be attached to the Component.


    var ForwardedComponent = (0,react.forwardRef)(function (props, ref) {
      return (0,react.createElement)(AsyncScriptLoader, async_script_loader_extends({}, props, {
        forwardedRef: ref
      }));
    });
    ForwardedComponent.displayName = "AsyncScriptLoader(" + wrappedComponentName + ")";
    ForwardedComponent.propTypes = {
      asyncScriptOnLoad: (prop_types_default()).func
    };
    return hoist_non_react_statics_cjs_default()(ForwardedComponent, WrappedComponent);
  };
}
;// CONCATENATED MODULE: ./node_modules/.pnpm/react-google-recaptcha@2.1.0_react@17.0.2/node_modules/react-google-recaptcha/lib/esm/recaptcha-wrapper.js


var callbackName = "onloadcallback";
var globalName = "grecaptcha";

function getOptions() {
  return typeof window !== "undefined" && window.recaptchaOptions || {};
}

function getURL() {
  var dynamicOptions = getOptions();
  var hostname = dynamicOptions.useRecaptchaNet ? "recaptcha.net" : "www.google.com";
  return "https://" + hostname + "/recaptcha/api.js?onload=" + callbackName + "&render=explicit";
}

/* harmony default export */ var recaptcha_wrapper = (makeAsyncScript(getURL, {
  callbackName: callbackName,
  globalName: globalName
})(ReCAPTCHA));
;// CONCATENATED MODULE: ./node_modules/.pnpm/react-google-recaptcha@2.1.0_react@17.0.2/node_modules/react-google-recaptcha/lib/esm/index.js


/* harmony default export */ var esm = (recaptcha_wrapper);

// EXTERNAL MODULE: ./node_modules/.pnpm/react-hook-form@7.28.0_react@17.0.2/node_modules/react-hook-form/dist/index.esm.mjs
var index_esm = __webpack_require__(90300);
// EXTERNAL MODULE: ./src/components/_form/ReCaptcha/recaptcha.module.scss
var recaptcha_module = __webpack_require__(5168);
var recaptcha_module_default = /*#__PURE__*/__webpack_require__.n(recaptcha_module);
;// CONCATENATED MODULE: ./src/components/_form/ReCaptcha/index.tsx






function ReCaptcha(props) {
    var onRecaptchaChange = function onRecaptchaChange(token) {
        setValue(name, token || undefined, {
            // only validate when the user clicks on it,
            // and not when a challenge expires (token is null in this case)
            // recaptcha managing his own expiration message
            shouldValidate: !!token
        });
    };
    var ref = (0,index_esm/* useController */.bc)(props), name = ref.field.name, error = ref.fieldState.error;
    var setValue = props.setValue;
    return(/*#__PURE__*/ (0,jsx_runtime.jsxs)(Row/* default */.Z, {
        className: "m-5",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Col/* default */.Z, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Col/* default */.Z, {
                sm: "8",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(esm, {
                        sitekey: consts_recaptchaKey,
                        /* eslint-disable-next-line */ onChange: onRecaptchaChange
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        className: error ? (recaptcha_module_default()).errorMessage : 'd-none',
                        children: error === null || error === void 0 ? void 0 : error.message
                    })
                ]
            })
        ]
    }));
}
/* harmony default export */ var _form_ReCaptcha = (ReCaptcha);

// EXTERNAL MODULE: ./src/components/_form/Select/ProfileSelect/index.tsx
var ProfileSelect = __webpack_require__(63484);
// EXTERNAL MODULE: ./src/hooks/useApi.ts
var useApi = __webpack_require__(7920);
// EXTERNAL MODULE: ./src/consts/paths/api/auth/requestAccess.ts
var requestAccess = __webpack_require__(77480);
// EXTERNAL MODULE: ./src/components/_form/Select/CountrySelect/index.tsx
var CountrySelect = __webpack_require__(27824);
// EXTERNAL MODULE: ./src/components/_form/Select/ProfileSelect/profileselect.module.scss
var profileselect_module = __webpack_require__(15824);
var profileselect_module_default = /*#__PURE__*/__webpack_require__.n(profileselect_module);
// EXTERNAL MODULE: ./src/components/LoginPage/RequestAccess/FormModal/_requestAccess.module.scss
var _requestAccess_module = __webpack_require__(9784);
var _requestAccess_module_default = /*#__PURE__*/__webpack_require__.n(_requestAccess_module);
// EXTERNAL MODULE: ./node_modules/.pnpm/yup@0.32.11/node_modules/yup/es/index.js + 25 modules
var es = __webpack_require__(55423);
// EXTERNAL MODULE: ./src/functions/validation/getIsRequiredText.ts
var getIsRequiredText = __webpack_require__(42590);
// EXTERNAL MODULE: ./src/components/_form/schema-presets.ts
var schema_presets = __webpack_require__(31500);
;// CONCATENATED MODULE: ./src/components/LoginPage/RequestAccess/FormModal/schema.ts



var requestAccessSchema = es/* object */.Ry().shape({
    profile: es/* string */.Z_().required((0,getIsRequiredText/* default */.Z)('Profile')),
    name: es/* string */.Z_().required((0,getIsRequiredText/* default */.Z)('Name')),
    email: es/* string */.Z_().email('Email must be a valid email').required((0,getIsRequiredText/* default */.Z)('Email')),
    password: schema_presets/* passwordRequiredSchema */.EV,
    confirmPassword: es/* string */.Z_().required((0,getIsRequiredText/* default */.Z)('Confirm password')).oneOf([
        es/* ref */.iH('password')
    ], 'Passwords must match'),
    country: es/* string */.Z_().required((0,getIsRequiredText/* default */.Z)('Country')).min(2),
    organisation: es/* string */.Z_().required((0,getIsRequiredText/* default */.Z)('Organisation')),
    motivation: es/* string */.Z_().required((0,getIsRequiredText/* default */.Z)('Motivation')),
    recaptchaResponse: es/* string */.Z_().required((0,getIsRequiredText/* default */.Z)('Recaptcha response'))
});
var requestAccessDefaultValues = {
    profile: '',
    name: '',
    email: '',
    password: '',
    confirmPassword: '',
    country: '',
    organisation: '',
    motivation: '',
    recaptchaResponse: ''
};

;// CONCATENATED MODULE: ./src/components/LoginPage/RequestAccess/FormModal/index.tsx


/* eslint-disable @typescript-eslint/no-unsafe-assignment,react/jsx-props-no-spreading */ 










function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
var RequestAccessFormModal = function(param1) {
    var isShowing = param1.isShowing, toggle = param1.toggle, onComplete = param1.onComplete;
    var api = (0,useApi/* default */.Z)();
    var sendRequestAccess = function() {
        var _ref = _asyncToGenerator(runtime_default().mark(function _callee(data) {
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        return _ctx.abrupt("return", api.post(requestAccess/* default */.Z, data));
                    case 1:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function sendRequestAccess(data) {
            return _ref.apply(this, arguments);
        };
    }();
    return(/*#__PURE__*/ (0,jsx_runtime.jsx)(FormModal/* default */.Z, {
        title: "Request access",
        toggle: toggle,
        isShowing: isShowing,
        validationSchema: requestAccessSchema,
        submitButtonText: "Request access",
        initialValues: requestAccessDefaultValues,
        onSubmit: sendRequestAccess,
        onComplete: onComplete,
        customSize: true,
        isResetAfterSubmit: true,
        children: function(param) {
            var register = param.register, setValue = param.setValue, control = param.control, errors = param.formState.errors, watch = param.watch;
            /*#__PURE__*/ return (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        className: (_requestAccess_module_default()).formDescription,
                        children: "After filling in the form, you will be contacted by an administrator."
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        className: (_requestAccess_module_default()).formDescription,
                        children: "Your account can be activated only by an administrator. Please make sure your e-mail address is correct."
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("hr", {
                        className: (_requestAccess_module_default()).horizontal
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Field/* default */.Z, {
                        label: "profile",
                        id: "profile",
                        feedback: errors.profile,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(ProfileSelect/* default */.Z, {
                                control: control,
                                name: "profile",
                                label: "Choose the profile that best describes you..."
                            }),
                            !watch('profile') && /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                className: "".concat((profileselect_module_default()).profileDescription, " mt-3"),
                                children: "You are a member of the EORTC Quality of Life Group and need access to the Item Library for managing requests."
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Field/* default */.Z, {
                        label: "name",
                        id: "name",
                        feedback: errors.name,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Form/* default.Control */.Z.Control, _objectSpread({
                            isInvalid: !!errors.name,
                            placeholder: "Your full name, e. g. John Doe"
                        }, register('name')))
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Field/* default */.Z, {
                        label: "email",
                        id: "email",
                        feedback: errors.email,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Form/* default.Control */.Z.Control, _objectSpread({
                            type: "email"
                        }, register('email'), {
                            placeholder: "Your email addres (will also be your login)",
                            isInvalid: !!errors.email
                        }))
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Field/* default */.Z, {
                        label: "password",
                        id: "password",
                        feedback: errors.password,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Form/* default.Control */.Z.Control, _objectSpread({
                            type: "password"
                        }, register('password'), {
                            placeholder: "chose a password..",
                            isInvalid: !!errors.password
                        }))
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Field/* default */.Z, {
                        label: "confirm password",
                        id: "confirmPassword",
                        feedback: errors.confirmPassword,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Form/* default.Control */.Z.Control, _objectSpread({
                            type: "password"
                        }, register('confirmPassword'), {
                            isInvalid: !!errors.confirmPassword
                        }))
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Field/* default */.Z, {
                        label: "country",
                        id: "country",
                        feedback: errors.country,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CountrySelect/* default */.Z, {
                            control: control,
                            name: "country",
                            label: "Your country of residence"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Field/* default */.Z, {
                        label: "organisation",
                        id: "organisation",
                        feedback: errors.organisation,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Form/* default.Control */.Z.Control, _objectSpread({
                            placeholder: "The company or institution you work for"
                        }, register('organisation'), {
                            isInvalid: !!errors.organisation
                        }))
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Field/* default */.Z, {
                        label: "motivation",
                        id: "motivation",
                        feedback: errors.motivation,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Form/* default.Control */.Z.Control, _objectSpread({
                            as: "textarea",
                            placeholder: "Why you need to access the item library"
                        }, register('motivation'), {
                            isInvalid: !!errors.motivation
                        }))
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("hr", {
                        className: (_requestAccess_module_default()).horizontal
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(_form_ReCaptcha, {
                        name: "recaptchaResponse",
                        setValue: setValue,
                        control: control
                    })
                ]
            });
        }
    }));
};
/* harmony default export */ var RequestAccess_FormModal = (RequestAccessFormModal);

;// CONCATENATED MODULE: ./src/components/LoginPage/RequestAccess/RequestSent/index.tsx

var RequestSent = function() {
    /*#__PURE__*/ return (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "p-3",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                    children: " The Item Library administrator will contact you by e-mail."
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                    children: "Once your account has been activated, you will receive an e-mail notification."
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                    children: [
                        "In case of any problems, please contact us at",
                        ' ',
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                            href: "\\\"mailto:itemlibrary@eortc.org\\\"",
                            children: "itemlibrary@eortc.org"
                        }),
                        "."
                    ]
                })
            ]
        })
    });
};
/* harmony default export */ var RequestAccess_RequestSent = (RequestSent);

;// CONCATENATED MODULE: ./src/components/LoginPage/RequestAccess/index.tsx





var RequestAccess = function(param) {
    var toggle = param.toggle, isShowing = param.isShowing;
    var ref = (0,react.useState)(false), isComplete = ref[0], setIsComplete = ref[1];
    var onComplete = (0,react.useCallback)(function() {
        setIsComplete(true);
    }, []);
    (0,react.useEffect)(function() {
        // we need to reset it on toggle
        setIsComplete(false);
    }, [
        toggle
    ]);
    return(/*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: isComplete ? /*#__PURE__*/ (0,jsx_runtime.jsx)(MessageBox/* default */.Z, {
            title: "Request submitted!",
            isShowing: isShowing,
            toggle: toggle,
            onComplete: onComplete,
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(RequestAccess_RequestSent, {})
        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(RequestAccess_FormModal, {
            toggle: toggle,
            isShowing: isShowing,
            onComplete: onComplete
        })
    }));
};
/* harmony default export */ var LoginPage_RequestAccess = (RequestAccess);

// EXTERNAL MODULE: ./node_modules/.pnpm/next@12.1.0_n6febsnk4nq7zxsovmf65ymnxm/node_modules/next/router.js
var next_router = __webpack_require__(63359);
;// CONCATENATED MODULE: ./src/components/LoginPage/ResetPasswordSuccessfulModal/index.tsx





function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function _iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
var ResetPasswordSuccessfulModal = function() {
    var ref1 = _slicedToArray((0,useModal/* default */.Z)(), 2), isShowing = ref1[0], toggle = ref1[1];
    var router = (0,next_router.useRouter)();
    var onMessageBoxClose = function() {
        void router.replace('/', undefined, {
            shallow: true
        });
    };
    (0,react.useEffect)(function() {
        var ref;
        if (router === null || router === void 0 ? void 0 : (ref = router.query) === null || ref === void 0 ? void 0 : ref.resetSuccessful) {
            toggle();
        }
    // eslint-disable-next-line
    }, []);
    return(/*#__PURE__*/ (0,jsx_runtime.jsx)(MessageBox/* default */.Z, {
        title: "Password reset!",
        isShowing: isShowing,
        onComplete: onMessageBoxClose,
        toggle: toggle,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
            className: "px-3 py-1 m-0",
            children: "You can now use your new password to login."
        })
    }));
};
/* harmony default export */ var LoginPage_ResetPasswordSuccessfulModal = (ResetPasswordSuccessfulModal);

// EXTERNAL MODULE: ./src/components/LoginPage/login.module.scss
var login_module = __webpack_require__(82637);
var login_module_default = /*#__PURE__*/__webpack_require__.n(login_module);
// EXTERNAL MODULE: ./src/elements/Warning/index.tsx
var Warning = __webpack_require__(34155);
// EXTERNAL MODULE: ./src/elements/ButtonWithLoader/index.tsx
var ButtonWithLoader = __webpack_require__(49788);
// EXTERNAL MODULE: ./src/components/_form/form.module.scss
var form_module = __webpack_require__(55644);
var form_module_default = /*#__PURE__*/__webpack_require__.n(form_module);
// EXTERNAL MODULE: ./src/hooks/useForm.tsx + 4 modules
var useForm = __webpack_require__(74766);
;// CONCATENATED MODULE: ./src/consts/paths/pages/reset-password.ts
var RESET_PASSWORD_PATH = '/reset-password?token=';
/* harmony default export */ function reset_password() {
    return new URL(RESET_PASSWORD_PATH, document.baseURI).href;
};

// EXTERNAL MODULE: ./src/consts/paths/api/auth/forgotPassword.ts
var forgotPassword = __webpack_require__(58065);
;// CONCATENATED MODULE: ./src/components/LoginPage/ForgotPassword/FormModal/index.tsx


/* eslint-disable @typescript-eslint/no-unsafe-assignment,react/jsx-props-no-spreading */ 







function FormModal_asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function FormModal_asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                FormModal_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                FormModal_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function FormModal_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function FormModal_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            FormModal_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
var schema = es/* object */.Ry().shape({
    email: schema_presets/* emailRequiredSchema */.bo
});
var ForgotPasswordFormModal = function(param1) {
    var toggle = param1.toggle, isShowing = param1.isShowing, onComplete = param1.onComplete;
    var api = (0,useApi/* default */.Z)();
    var initialValues = {
        email: ''
    };
    var onSubmit = function() {
        var _ref = FormModal_asyncToGenerator(runtime_default().mark(function _callee(param) {
            var email, url;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        email = param.email;
                        url = reset_password();
                        _ctx.next = 4;
                        return api.post(forgotPassword/* default */.Z, {
                            email: email,
                            url: url
                        });
                    case 4:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function onSubmit(_) {
            return _ref.apply(this, arguments);
        };
    }();
    return(/*#__PURE__*/ (0,jsx_runtime.jsx)(FormModal/* default */.Z, {
        title: "Forget password",
        toggle: toggle,
        isShowing: isShowing,
        validationSchema: schema,
        submitButtonText: "Send reset link",
        initialValues: initialValues,
        onSubmit: onSubmit,
        onComplete: onComplete,
        children: function(param) {
            var register = param.register, errors = param.formState.errors;
            var ref;
            /*#__PURE__*/ return (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        className: "mb-5",
                        children: "Enter the email address associated with your account, and we will email you a link to reset your password."
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Form/* default.Group */.Z.Group, {
                        className: "mb-3",
                        controlId: "email",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Form/* default.Control */.Z.Control, FormModal_objectSpread({
                                className: (form_module_default()).formInput,
                                type: "email",
                                placeholder: "Email"
                            }, register('email'), {
                                isInvalid: !!errors.email
                            })),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Form/* default.Control.Feedback */.Z.Control.Feedback, {
                                type: "invalid",
                                className: "ms-2",
                                children: (ref = errors.email) === null || ref === void 0 ? void 0 : ref.message
                            })
                        ]
                    })
                ]
            });
        }
    }));
};
/* harmony default export */ var ForgotPassword_FormModal = (ForgotPasswordFormModal);

;// CONCATENATED MODULE: ./src/components/LoginPage/ForgotPassword/EmailSentModal/index.tsx

var ForgotPasswordEmailSent = function(param) {
    var email = param.email;
    /*#__PURE__*/ return (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
            className: "p-4 text-secondary",
            children: [
                "A link to reset your password has been sent to ",
                email
            ]
        })
    });
};
/* harmony default export */ var EmailSentModal = (ForgotPasswordEmailSent);

;// CONCATENATED MODULE: ./src/components/LoginPage/ForgotPassword/index.tsx





var ForgotPassword = function(param1) {
    var toggle = param1.toggle, isShowing = param1.isShowing;
    var ref = (0,react.useState)(''), email = ref[0], setEmail = ref[1];
    var onComplete = (0,react.useCallback)(function(param) {
        var _email = param.email;
        setEmail(_email);
    }, []);
    return(/*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: email ? /*#__PURE__*/ (0,jsx_runtime.jsx)(MessageBox/* default */.Z, {
            title: "Email sent!",
            onComplete: onComplete,
            isShowing: isShowing,
            toggle: toggle,
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(EmailSentModal, {
                email: email
            })
        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(ForgotPassword_FormModal, {
            toggle: toggle,
            isShowing: isShowing,
            onComplete: onComplete
        })
    }));
};
/* harmony default export */ var LoginPage_ForgotPassword = (ForgotPassword);

// EXTERNAL MODULE: ./src/hooks/useUserSession/index.ts + 2 modules
var useUserSession = __webpack_require__(39955);
;// CONCATENATED MODULE: ./src/components/LoginPage/LoginForm/index.tsx


/* eslint-disable react/jsx-props-no-spreading */ 











function LoginForm_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function LoginForm_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function LoginForm_asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function LoginForm_asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                LoginForm_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                LoginForm_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function LoginForm_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function LoginForm_iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function LoginForm_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function LoginForm_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            LoginForm_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function LoginForm_slicedToArray(arr, i) {
    return LoginForm_arrayWithHoles(arr) || LoginForm_iterableToArrayLimit(arr, i) || LoginForm_unsupportedIterableToArray(arr, i) || LoginForm_nonIterableRest();
}
function LoginForm_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return LoginForm_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return LoginForm_arrayLikeToArray(o, minLen);
}
var LoginForm_schema = es/* object */.Ry().shape({
    email: schema_presets/* emailRequiredSchema */.bo,
    password: schema_presets/* passwordRequiredSchema */.EV
});
var Login = function(props) {
    var ref, ref1;
    var ref2 = LoginForm_slicedToArray((0,useModal/* default */.Z)(), 2), isRequestAccessShowing = ref2[0], toggleRequestAccessModal = ref2[1];
    var ref3 = LoginForm_slicedToArray((0,useModal/* default */.Z)(), 2), isForgotPasswordShowing = ref3[0], toggleForgotPasswordModal = ref3[1];
    var logOn = (0,useUserSession/* default */.Z)().logOn;
    var onSubmit = function() {
        var _ref = LoginForm_asyncToGenerator(runtime_default().mark(function _callee(param) {
            var email, password;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        email = param.email, password = param.password;
                        _ctx.next = 3;
                        return logOn(email, password);
                    case 3:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function onSubmit(_) {
            return _ref.apply(this, arguments);
        };
    }();
    var ref4 = (0,useForm/* default */.Z)({
        schema: LoginForm_schema,
        onSubmit: onSubmit,
        defaultValues: props
    }), register = ref4.register, isLoading = ref4.isLoading, warningMessage = ref4.warningMessage, errors = ref4.formState.errors, handleSubmit = ref4.handleSubmit;
    (0,react.useEffect)(function() {
        var keyDownHandler = function(event) {
            if (event.key === 'Enter') {
                event.preventDefault();
                handleSubmit();
            }
        };
        document.addEventListener('keydown', keyDownHandler);
        return function() {
            document.removeEventListener('keydown', keyDownHandler);
        };
    }, [
        handleSubmit
    ]);
    return(/*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (form_module_default()).formWrapper,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Warning/* default */.Z, {
                show: !!warningMessage,
                text: warningMessage
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Form/* default */.Z, {
                noValidate: true,
                className: "".concat((form_module_default()).form),
                onSubmit: handleSubmit,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                        className: (form_module_default()).formTitle,
                        children: "Log In"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Form/* default.Group */.Z.Group, {
                        className: "mb-4",
                        controlId: "loginEmail",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Form/* default.Label */.Z.Label, {
                                className: (form_module_default()).formFieldLabel,
                                children: "Email"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Form/* default.Control */.Z.Control, LoginForm_objectSpread({
                                className: (form_module_default()).formInput,
                                type: "email",
                                placeholder: "",
                                isInvalid: !!errors.email
                            }, register('email'))),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Form/* default.Control.Feedback */.Z.Control.Feedback, {
                                type: "invalid",
                                children: (ref = errors.email) === null || ref === void 0 ? void 0 : ref.message
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Form/* default.Group */.Z.Group, {
                        className: "mb-4",
                        controlId: "loginPassword",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Form/* default.Label */.Z.Label, {
                                className: (form_module_default()).formFieldLabel,
                                children: "Password"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Form/* default.Control */.Z.Control, LoginForm_objectSpread({
                                className: (form_module_default()).formInput,
                                type: "password",
                                placeholder: "",
                                isInvalid: !!errors.password
                            }, register('password'))),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Form/* default.Control.Feedback */.Z.Control.Feedback, {
                                type: "invalid",
                                children: (ref1 = errors.password) === null || ref1 === void 0 ? void 0 : ref1.message
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ButtonWithLoader/* default */.Z, {
                        onClick: handleSubmit,
                        isLoading: isLoading,
                        children: "Log in"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                        type: "button",
                        className: "".concat((form_module_default()).formLinks, " mt-3"),
                        onClick: toggleForgotPasswordModal,
                        children: "Forgot your password?"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                        type: "button",
                        className: "".concat((form_module_default()).formLinks, " mb-2"),
                        onClick: toggleRequestAccessModal,
                        children: "No account? Request access"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(LoginPage_ForgotPassword, {
                        isShowing: isForgotPasswordShowing,
                        toggle: toggleForgotPasswordModal
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(LoginPage_RequestAccess, {
                        isShowing: isRequestAccessShowing,
                        toggle: toggleRequestAccessModal
                    })
                ]
            })
        ]
    }));
};
/* harmony default export */ var LoginForm = (Login);

// EXTERNAL MODULE: ./src/layout/Layout/LoggedOutLayout/index.tsx + 1 modules
var LoggedOutLayout = __webpack_require__(20298);
;// CONCATENATED MODULE: ./src/components/LoginPage/index.tsx








function LoginPage_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function LoginPage_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function LoginPage_iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function LoginPage_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function LoginPage_slicedToArray(arr, i) {
    return LoginPage_arrayWithHoles(arr) || LoginPage_iterableToArrayLimit(arr, i) || LoginPage_unsupportedIterableToArray(arr, i) || LoginPage_nonIterableRest();
}
function LoginPage_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return LoginPage_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return LoginPage_arrayLikeToArray(o, minLen);
}
var LoginPage = function() {
    var ref = LoginPage_slicedToArray((0,useModal/* default */.Z)(), 2), isShowing = ref[0], toggle = ref[1];
    return(/*#__PURE__*/ (0,jsx_runtime.jsxs)(Container/* default */.Z, {
        className: (login_module_default()).loginWrapper,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Row/* default */.Z, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Col/* default */.Z, {
                        sm: "6",
                        className: "px-4",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                className: (login_module_default()).title,
                                children: "EORTC Quality of Life Group Item Library"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                className: (login_module_default()).lead,
                                children: "The Item Library is a database of items used in fully and partially validated EORTC quality of life questionnaires."
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                children: "This tool has been created by the EORTC Quality of Life Group with the primary aim of being used during the development of new instruments."
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                children: "Developers can access it to see how items were formulated in previous questionnaires and to reuse existing validated items and their translations."
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                children: "Access to the Item Library can also be granted to academic and commercial users as a reference tool."
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                variant: "outline-primary",
                                className: (login_module_default()).button,
                                onClick: toggle,
                                children: "Request access"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Col/* default */.Z, {
                        sm: "6",
                        className: "px-4",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(LoginForm, {})
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(LoginPage_RequestAccess, {
                isShowing: isShowing,
                toggle: toggle
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(LoginPage_ResetPasswordSuccessfulModal, {})
        ]
    }));
};
LoginPage.layout = LoggedOutLayout/* default */.Z;
/* harmony default export */ var components_LoginPage = (LoginPage);

// EXTERNAL MODULE: ./src/components/PageWrapper/pageWrapper.module.scss
var pageWrapper_module = __webpack_require__(7806);
var pageWrapper_module_default = /*#__PURE__*/__webpack_require__.n(pageWrapper_module);
// EXTERNAL MODULE: ./src/components/_form/GeneralSearchPanel/index.tsx + 5 modules
var GeneralSearchPanel = __webpack_require__(45892);
// EXTERNAL MODULE: ./src/components/_navigation/PageNavigation/index.tsx
var PageNavigation = __webpack_require__(64456);
;// CONCATENATED MODULE: ./src/components/PageWrapper/HomePageWrapper/index.tsx







var navUrls = [
    {
        url: '/',
        label: 'Official questionnaires'
    },
    {
        url: '/myCustom',
        label: 'Custom questionnaires'
    },
    {
        url: '/tree-view',
        label: 'Item classification'
    }, 
];
var HomePageWrapper = function(param) {
    var children = param.children;
    var isAuthenticated = (0,useUserSession/* default */.Z)().isAuthenticated;
    if (!isAuthenticated) {
        return(/*#__PURE__*/ (0,jsx_runtime.jsx)(components_LoginPage, {}));
    }
    return(/*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(GeneralSearchPanel/* default */.Z, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(PageNavigation/* default */.Z, {
                navUrls: navUrls
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (pageWrapper_module_default()).indexBg,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Container/* default */.Z, {
                    className: (pageWrapper_module_default()).wrapper,
                    children: children
                })
            })
        ]
    }));
};
/* harmony default export */ var PageWrapper_HomePageWrapper = (HomePageWrapper);


/***/ }),

/***/ 63484:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(4637);
/* harmony import */ var react_hook_form__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(90300);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(59496);
/* harmony import */ var hooks_useProfiles__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(32535);
/* harmony import */ var _profileselect_module_scss__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(15824);
/* harmony import */ var _profileselect_module_scss__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_profileselect_module_scss__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var ___WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(2103);






function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function FormProfileSelect(props) {
    var field = (0,react_hook_form__WEBPACK_IMPORTED_MODULE_1__/* .useController */ .bc)(props).field;
    var control = props.control, isForAdminPanel = props.isForAdminPanel;
    var ref = (0,hooks_useProfiles__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(), profiles = ref.profiles, findProfileById = ref.findProfileById;
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(), selectedProfileDescription1 = ref1[0], setSelectedProfileDescription = ref1[1];
    var profileId = (0,react_hook_form__WEBPACK_IMPORTED_MODULE_1__/* .useWatch */ .qo)({
        control: control,
        name: field.name
    });
    (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(function() {
        var selectedProfile = findProfileById(profileId);
        var selectedProfileDescription = isForAdminPanel ? (selectedProfile === null || selectedProfile === void 0 ? void 0 : selectedProfile.adminDescription) || '' : (selectedProfile === null || selectedProfile === void 0 ? void 0 : selectedProfile.description) || '';
        setSelectedProfileDescription(selectedProfileDescription);
    }, [
        isForAdminPanel,
        profileId,
        findProfileById
    ]);
    var getItems = function() {
        if (!profiles) return;
        var profilesToRender = profiles;
        if (!isForAdminPanel) {
            profilesToRender = profilesToRender.filter(function(item) {
                return item.description !== '';
            });
        }
        return profilesToRender.map(function(param) {
            var id = param.id, label = param.label;
            return {
                value: id,
                label: label
            };
        });
    };
    return(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(___WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, _objectSpread({}, props, {
                items: getItems()
            })),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                className: selectedProfileDescription1 ? "".concat((_profileselect_module_scss__WEBPACK_IMPORTED_MODULE_5___default().profileDescription), " mt-3") : 'd-none',
                children: selectedProfileDescription1
            })
        ]
    }));
}
/* harmony default export */ __webpack_exports__["Z"] = (FormProfileSelect);


/***/ }),

/***/ 64456:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(4637);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(70462);
/* harmony import */ var react_bootstrap__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(44858);
/* harmony import */ var react_bootstrap__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(42359);
/* harmony import */ var _pageNavigation_module_scss__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(82414);
/* harmony import */ var _pageNavigation_module_scss__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_pageNavigation_module_scss__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(63359);





var PageNavigation = function(param) {
    var navUrls = param.navUrls;
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_2__.useRouter)();
    return(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_bootstrap__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
        className: (_pageNavigation_module_scss__WEBPACK_IMPORTED_MODULE_4___default().wrapper),
        children: navUrls.map(function(navElement) {
            /*#__PURE__*/ return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_bootstrap__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                sm: 4,
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(next_link__WEBPACK_IMPORTED_MODULE_1__["default"], {
                    href: navElement.url,
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                        className: router.pathname === navElement.url ? (_pageNavigation_module_scss__WEBPACK_IMPORTED_MODULE_4___default().active) : '',
                        children: navElement.label
                    })
                })
            }, navElement.url);
        })
    }));
};
/* harmony default export */ __webpack_exports__["Z"] = (PageNavigation);


/***/ }),

/***/ 32535:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _builds_dTaaiTbB_0_emakina_group_emakina_be_eortc_eortc_item_library_front_node_modules_pnpm_next_12_1_0_n6febsnk4nq7zxsovmf65ymnxm_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(95601);
/* harmony import */ var _builds_dTaaiTbB_0_emakina_group_emakina_be_eortc_eortc_item_library_front_node_modules_pnpm_next_12_1_0_n6febsnk4nq7zxsovmf65ymnxm_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_builds_dTaaiTbB_0_emakina_group_emakina_be_eortc_eortc_item_library_front_node_modules_pnpm_next_12_1_0_n6febsnk4nq7zxsovmf65ymnxm_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(59496);
/* harmony import */ var ramda__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(62058);



function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
var useProfiles = function() {
    var ref2 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)({
        profiles: undefined,
        profilesIndex: undefined
    }), ref1 = ref2[0], profiles1 = ref1.profiles, profilesIndex1 = ref1.profilesIndex, setProfiles = ref2[1];
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        void _asyncToGenerator(_builds_dTaaiTbB_0_emakina_group_emakina_be_eortc_eortc_item_library_front_node_modules_pnpm_next_12_1_0_n6febsnk4nq7zxsovmf65ymnxm_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
            var profiles, profilesIndex;
            return _builds_dTaaiTbB_0_emakina_group_emakina_be_eortc_eortc_item_library_front_node_modules_pnpm_next_12_1_0_n6febsnk4nq7zxsovmf65ymnxm_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.next = 2;
                        return __webpack_require__.e(/* import() */ 434).then(__webpack_require__.t.bind(__webpack_require__, 51434, 19));
                    case 2:
                        profiles = _ctx.sent.default;
                        profilesIndex = (0,ramda__WEBPACK_IMPORTED_MODULE_2__/* .indexBy */ .HK3)((0,ramda__WEBPACK_IMPORTED_MODULE_2__/* .prop */ .vgT)('id'), profiles);
                        setProfiles({
                            profiles: profiles,
                            profilesIndex: profilesIndex
                        });
                    case 5:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }))();
    }, []);
    var findProfileById = function(id) {
        return profilesIndex1 && profilesIndex1[id];
    };
    var getProfileShortLabel = function(id) {
        var ref;
        return (ref = findProfileById(id)) === null || ref === void 0 ? void 0 : ref.shortLabel;
    };
    return {
        profiles: profiles1,
        findProfileById: findProfileById,
        getProfileShortLabel: getProfileShortLabel
    };
};
/* harmony default export */ __webpack_exports__["Z"] = (useProfiles);


/***/ }),

/***/ 9784:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"customModal":"_requestAccess_customModal__5cqPq","formDescription":"_requestAccess_formDescription__05yJy","horizontal":"_requestAccess_horizontal__x4i4c"};

/***/ }),

/***/ 82637:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"loginWrapper":"login_loginWrapper__xa6DS","title":"login_title__6T8zf","lead":"login_lead__Eqda3","button":"login_button__MiOvx"};

/***/ }),

/***/ 7806:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"indexBg":"pageWrapper_indexBg__FGi7d","wrapper":"pageWrapper_wrapper__GwCE3"};

/***/ }),

/***/ 5168:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"errorMessage":"recaptcha_errorMessage__ymIFP"};

/***/ }),

/***/ 15824:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"profileDescription":"profileselect_profileDescription___R5sm"};

/***/ }),

/***/ 82414:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"pageNavigation_wrapper__rOSnz","active":"pageNavigation_active__OTvvW"};

/***/ })

}]);